<template>
  <div class="site">
    <div class="box">
      <h1>基因解读-{{ $route.query.gene }}</h1>
      <div class="show-box"></div>
      <div class="text" v-html="geneData.geneDesc"></div>
    </div>
    <div class="box">
      <h1>FDA/NMPA 批准适应症</h1>
      <div class="show-box"></div>
      <div class="text" v-html="geneData.clinicalSignificance"></div>
    </div>
  </div>
</template>
<script>
import { findGeneDepict } from "@/api/wxapi.js";
export default {
  data() {
    return {
      geneData: {},
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      findGeneDepict({
        geneName: this.$route.query.gene,
        labOriginalSampleNo: this.$route.query.fname,
        productCode: this.$route.query.fid,
      }).then((res) => {
        this.geneData = res.data[0];
      });
    },
  },
};
</script>

<style lang="less" scoped>
.site {
  padding: 20px 16px;
  .box {
    border-radius: 10px;
    background: @background_color;
    margin-bottom: 20px;
    h1 {
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #2f354d;
      line-height: 70px;
      padding-left: 24px;
    }
    .text {
      padding: 10px 24px;
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #5f697d;
      line-height: 30px;
    }
  }
}
.show-box {
  height: 20px;
  background: linear-gradient(
    360deg,
    rgba(58, 74, 134, 0) 0%,
    rgba(58, 74, 134, 0.1) 100%
  );
}
</style>